import { useState, useEffect } from 'react';
import { BasicTable } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { Selectorconstcode } from "../../Selectorconstcode";
import { RenderForm } from "../../../../../theme/Component/RenderForm";
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _FormParamDinamic, _single } from '../../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import useModal, { MODAL_LG, MODAL_SM } from '../../../../../theme/Component/hooks/useModal';
import { SelectTHConstants } from '../../../THConstants/SelectTHConstants';
import { SelectRemoteAbstractAction } from '../../../../../system/remoteAbstractAction/SelectRemoteAbstractAction';

interface Props {
    idSelector: number;
    CodePar: number;
}

export const FormParamDinamic = ({ idSelector, CodePar }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_FormParamDinamic)


    const modal = useModal("", MODAL_LG);
    const modalC = useModal(`Eliminar propiedad ${bean.PropertyName}`, MODAL_SM);

    const head = [
        { title: 'ID', property: "IDFormParam" },
        { title: 'Ubicacion', property: "IndexContinuity" },
        { title: 'Tamaño columnas', property: 'ColumnSize' },
        { title: 'Nombre de la propiedad', property: 'PropertyName' },
        { title: 'Etiqueta del campo', property: 'Label' },
        { title: 'Campo Requerido', property: 'RequiredCamp' },
    ]

    useEffect(() => {
        getLista();
    }, [idSelector])

    const getLista = () => {
        let props: any = {
            IDFormType: idSelector
        }
        instance.getFormParamCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) });
    }

    const agregarItem = () => {
        setBean({
            IDFormType: idSelector,
            State: 1,
            RequiredCamp: false
        });
        modal.open("Agregar Parametro al formulario dinamico");
    }

    const invalidPropertyNames = [
        "Description",
        "ProjectName",
        "AccountantIDName",
        "Name",
        "BudgetResourceName",
        "WelfareEntityName",
        "EmployeeNamefor"
    ];

    const invalidNamesProperties = (): boolean => {
        const propertyName = bean.PropertyName?.trim();

        if (!propertyName) {
            toast.error("Nombre de propiedad es obligatorio");
            return true;
        }

        if (invalidPropertyNames.includes(propertyName)) {
            toast.error("Nombre de propiedad es invalido");
            return true;
        }
        const LabelName = bean.PropertyName?.trim();

        if (!LabelName) {
            toast.error("Etiqueta del campo es obligatorio");
            return true;
        }

        if (invalidPropertyNames.includes(LabelName)) {
            toast.error("Etiqueta del campo es invalido");
            return true;
        }

        return false;
    };

    const updateItem = () => {
        if (invalidNamesProperties()) return;

        instance.updateFormParam(bean)
            .then(() => {
                getLista();
                modal.close();
            })
            .catch(err => toast.error(err));
    };

    const deleteItem = () => {
        instance.deleteFormParam(bean.IDFormParam).then(
            (resp) => {
                getLista();
                modalC.close()
            }
        ).catch(err => {
            toast.error(err)
        })
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { modal.open(`Editar campo ${bean.PropertyName}`); } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { modalC.open(); } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: agregarItem }
    ]

    return (
        <>
            <div className="row">
                <div className="col-md-12 p-2">
                    <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setBean}></BasicTable>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <RenderForm idFormType={CodePar} handleUpdate={(e) => { console.log(e) }} modeTest={true} />
                </div>
            </div>

            <Modal modal={modalC.modal} updateModal={modalC.setModal} eventModal={() => { deleteItem() }} >
                Desea eliminar {bean.Label}
            </Modal>

            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { updateItem() }}>
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Etiqueta del campo</label>
                        <input type="text" className="form-control" value={bean.Label} onChange={(e) => { setBean({ ...bean, Label: e.target.value }) }} />

                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Nombre de la propiedad</label>
                        <input type="text" className="form-control" value={bean.PropertyName} onChange={(e) => { setBean({ ...bean, PropertyName: e.target.value }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Tipo de campo</label>
                        <select className="form-control" value={bean.FieldType} onChange={(e) => { setBean({ ...bean, FieldType: e.target.value }) }}>
                            <option value={0}>...</option>
                            <option value={1}>Texto</option>
                            <option value={2}>Numerico</option>
                            <option value={3}>Boolean</option>
                            <option value={4}>Text Area</option>
                            <option value={5}>Tabla Parametrica</option>
                            <option value={6}>Fecha</option>
                            <option value={7}>Remote Form</option>
                        </select>

                    </div>

                    {bean.FieldType == 5 &&
                        <div className="col-md-6">
                            <SelectTHConstants returnType='Object' label='Parametrica' idSelector={bean.CodePar} onChange={(e: any) => { setBean({ ...bean, 'CodePar': e.Code }) }} />
                        </div>
                    }

                    {bean.FieldType == 7 &&
                        <div className="col-md-6">
                            <SelectRemoteAbstractAction label='Objeto Remote' value={bean.EditorObjectClassForName} onChange={(e: any) => { setBean({ ...bean, ['EditorObjectClassForName']: e }) }} />
                        </div>
                    }
                    <div className="col-md-6">
                        <label >Tamaño</label>
                        <select className="form-control" value={bean.ColumnSize} onChange={(e) => {
                            const valor = e.target.value ? Number(e.target.value) : null;
                            setBean({ ...bean, ColumnSize: valor })
                        }}>
                            <option value={""}>...</option>
                            {[...Array(12)].map((_, i) => (
                                <option key={i + 1} value={i + 1}>
                                    {i + 1}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-6">
                        <label>Ubicacion</label>
                        <input type='number' value={bean.IndexContinuity} onChange={(e) => {
                            const valor = e.target.value ? Number(e.target.value) : null;
                            setBean({ ...bean, IndexContinuity: valor })
                        }} className="form-control"></input>
                    </div>



                    {/* <div className="col-md-6">                    
                        <label className="form-label">Código Tabla Parametrica</label>
                        <input type="text" className="form-control" value={bean.CodePar } onChange={(e)=>{setBean({...bean,['CodePar']:e.target.value})}}/>
                    </div>  */}
                    <div className="col-md-6">
                        <label className="form-label">Campo Requerido</label>
                        <BasicSwitch label="" estado={bean.RequiredCamp} eventChange={(e: any) => { setBean({ ...bean, "RequiredCamp": e }); }} />
                    </div>
                </div>
            </Modal>
        </>
    )
}